import { Controller } from 'stimulus';
import Animation from 'src/animation';

import sprite1 from 'images/animations/tire_widths/1.png';
import sprite2 from 'images/animations/tire_widths/2.png';
import sprite3 from 'images/animations/tire_widths/3.png';
import sprite4 from 'images/animations/tire_widths/4.png';

export default class extends Controller {
  connect() {
    const ratio = 1.378;

    const options = {
      canvasWidth: this.element.offsetWidth,
      canvasHeight: this.element.offsetWidth / ratio,
      sources: this.sources,
      steps: this.steps,
      element: this.element
    };

    let rangeEl = this.element.querySelector('input')

    rangeEl.min = 0;
    rangeEl.max = 3;
    rangeEl.step = 1;
    rangeEl.value = 0;

    const animation = new Animation(options);

    let initialSprite = new Image();
    initialSprite.src = sprite1;
    initialSprite.onload = function() {
      animation.render(0)
    }
  }

  get sources() {
    return [
      sprite1,
      sprite2,
      sprite3,
      sprite4
    ]
  }

  get steps() {
    return [
      'The normal tire weight rating is established by the manufacturer and the states per inch rule for the tire width. As tire width increases, weight allowance also increases by both the manufacture and state law.',
      'So 650 pounds per inch on a standard 11” tire on an axle with one tire on each side will get you a <i>650*11*2</i>=14,300 pounds limit on that axle.',
      'If you had a wider tire, for example 15”, you’d get <i>650*15*2</i>=19,500 pounds limit on that axle.',
      'You could futher increase the tire width to get ever more weight, but wider tires are harder to steer. There is a tradeoff between maximum weight carried and the ability to steer.'
    ]
  }
}
